import { CommonModule, DecimalPipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AnalyticsService } from '../../../services/analytics.service';
import { DateUtilService } from '../../../services/dateUtil.service';
import { VendaPedrasPorMesApi } from '../../../models/analytics.model';

@Component({
  selector: 'app-venda-pedras-por-mes-chart',
  standalone: true,
  imports: [CommonModule, DecimalPipe],
  templateUrl: './venda-pedras-por-mes-chart.component.html',
  styleUrls: ['./venda-pedras-por-mes-chart.component.css']
})
export class VendaPedrasPorMesChartComponent implements OnInit {
  dados: VendaPedrasPorMesApi[] = [];
  isLoading = true;
  hasError = false;

  readonly dataInicial: string;
  readonly dataFinal: string;

  constructor(
    private analyticsService: AnalyticsService,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    private dateUtilService: DateUtilService
  ) {
    const hoje = this.dateUtilService.dataHoje;
    const [year, month] = hoje.split('-');
    this.dataInicial = `${year}-${month}-01`;
    this.dataFinal = hoje;
  }

  ngOnInit(): void {
    this.carregarDados();
  }

  carregarDados(): void {
    this.isLoading = true;
    this.hasError = false;

    this.analyticsService.getVendaPedrasPorMes(this.dataInicial, this.dataFinal).subscribe({
      next: (data) => {
        this.dados = Array.isArray(data) ? data : [];
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.isLoading = false;
        this.hasError = true;
        this.toastr.error('Erro ao carregar vendas de pedras por mês.');
        this.cdr.detectChanges();
      }
    });
  }

  get totalM2Vendido(): number {
    return this.dados.reduce((acc, item) => acc + (item.qtdM2VendidoMes ?? 0), 0);
  }

  get totalChapasEstimadas(): number {
    return this.dados.reduce((acc, item) => acc + (item.chapasEstimadas ?? 0), 0);
  }
}
